import React from 'react';
import { Button } from '@chakra-ui/core';

export const PrimaryButton = ({ children, _disabled, accessibleCoral = false, ...props }) => {
  const accentColor = accessibleCoral ? 'coral.700' : 'coral.900';

  return (
    <Button
      rounded="full"
      bg={accentColor}
      variantColor={null}
      color="white"
      height="auto"
      py="0.5em"
      px={props.rightIcon || props.leftIcon ? 6 : 5}
      _hover={{ bg: 'red' }}
      _disabled={{
        bg: 'lightGray2',
        cursor: 'not-allowed',
        a: { pointerEvents: 'none', cursor: 'not-allowed' },
        ..._disabled,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export const SecondaryButton = ({ children, accessibleCoral = false, ...props }) => {
  const accentColor = accessibleCoral ? 'coral.700' : 'coral.900';
  const hoverColor = accessibleCoral ? 'red' : 'white';
  const hoverBackground = accessibleCoral ? 'select.bg.isSelected' : accentColor;

  return (
    <PrimaryButton
      accessibleCoral={accessibleCoral}
      rounded="full"
      bg="transparent"
      variantColor={null}
      color={accentColor}
      borderWidth={1}
      borderColor={accentColor}
      _hover={{
        '&:not(:disabled)': {
          bg: hoverBackground,
          color: hoverColor,
          borderColor: accessibleCoral ? 'red' : accentColor,
        },
      }}
      _disabled={{
        borderColor: 'gray2',
        color: 'gray2',
        cursor: 'not-allowed',
        bg: 'transparent',
      }}
      {...props}
    >
      {children}
    </PrimaryButton>
  );
};
